import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    DatePicker,
    Paginate,
  },
  data: function () {
    return {
      role: "",
      branch: "",
      keyword: null,
      keyword_startdate: null,
      keyword_enddate: null,
      busy: false,
      totalItem: 0,
      currentPage: 1,
      currentData: {},
      apiStatus: "ไม่พบข้อมูล",
      perPage: 8,
      sortBy: "document_no",
      sortDesc: false,
      fields: [
        {
          key: "document_no",
          label: "เลขที่เอกสาร",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "customer_detail",
          label: "ลูกค้า",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
        },
        {
          key: "grand_total",
          label: "ยอดรวมสุทธิ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "creator_detail.name",
          label: "ผู้จัดทำ",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: true,
          class: "text-right",
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          class: "text-right",
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.getRole();
    this.onInitData(this.currentPage);
  },
  methods: {
    // ประเภท VAT: 1=แยก VAT, 2=รวม VAT, 0=ไม่เอา VAT (default 1)
    vatTypeLabel(t) {
      const v = Number(t);
      if (v === 2) return "รวม VAT";
      if (v === 0) return "ไม่มี VAT";
      return "แยก VAT";
    },
    vatTypeClass(t) {
      const v = Number(t);
      if (v === 2) return "badge-success";
      if (v === 0) return "badge-secondary";
      return "badge-primary";
    },
    // 4 = ยกเลิก (นิยามเดียวกับเอกสารอื่นในระบบ)
    isCancelled(item) {
      return String(item.status) === "4";
    },
    // ข้อความ tooltip ของ badge "ยกเลิก" — เหตุผล + ผู้ยกเลิก + วันที่
    // escape ก่อนเสมอ เพราะ tooltip เปิดโหมด html (เหตุผลเป็นข้อความที่ผู้ใช้พิมพ์เอง)
    cancelTooltip(item) {
      const esc = (s) =>
        String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");

      const parts = [];
      parts.push(`<div><strong>เหตุผล:</strong> ${esc(item.cancel_reason) || "-"}</div>`);
      if (item.canceller_detail && item.canceller_detail.name) {
        parts.push(`<div>โดย ${esc(item.canceller_detail.name)}</div>`);
      }
      if (item.cancelled_at) {
        const d = new Date(item.cancelled_at).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        parts.push(`<div>เมื่อ ${esc(d)}</div>`);
      }
      return parts.join("");
    },
    // วิธีชำระเงินเก็บเป็นรหัส — แปลงเป็นไทยตอนแสดง
    paymentLabel(v) {
      const map = { cash: "เงินสด", cheque: "เช็ค", transfer: "โอนเงิน", credit: "เครดิต" };
      return map[v] || v || "";
    },
    async getRole() {
      const res = await this.$store.dispatch("Auth/getRole", {}, { root: true });
      this.role = res.data.role;
      this.branch = res.data.branch_id;
    },
    oncreate() {
      this.$router.push("/tax/deposit-tax-create");
    },
    onedit(uuid) {
      const routeData = this.$router.resolve({
        path: "/tax/deposit-tax-create/" + uuid,
      });
      window.open(routeData.href, "_blank");
    },
    async onInitData(currentPage) {
      this.currentPage = currentPage;
      try {
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";

        const page = currentPage ? currentPage : 1;
        const url =
          `${Vue.prototype.$host}/api/v1/document/deposit-tax-invoice` +
          `?page=${page}&per_page=${this.perPage}` +
          `&keyword=${this.keyword || ""}` +
          `&keyword_start=${this.keyword_startdate ? moment(this.keyword_startdate).format("YYYY-MM-DD") : ""}` +
          `&keyword_end=${this.keyword_enddate ? moment(this.keyword_enddate).format("YYYY-MM-DD") : ""}`;

        const result = await Vue.prototype.$axios.get(url);

        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";

        if (result && result.data) {
          this.currentData = result.data;
          this.items = result.data.data || [];
          this.totalItem = result.data.total;
        } else {
          this.items = [];
          this.totalItem = 0;
        }
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler(
          error.response ? error.response.data.message : error.message
        );
      }
    },
    generatePDF(uuid) {
      try {
        this.loading = true;
        setTimeout(async () => {
          const result = await this.$axios.get(
            this.$host + "/api/v1/document/deposit-tax-invoice-pdf/" + uuid,
            {
              headers: { "Content-Type": "multipart/form-data" },
              responseType: "blob",
            }
          );
          const blob = new Blob([result.data], { type: "application/pdf" });
          const objectUrl = URL.createObjectURL(blob);
          window.open(
            objectUrl,
            "targetWindow",
            `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=SomeSize,height=SomeSize`
          );
          this.loading = false;
        }, 500);
      } catch (error) {
        this.loading = false;
        this.onExceptionHandler(
          error.response ? error.response.data.message : error.message
        );
      }
    },
    oncancel(item) {
      this.$swal({
        title: "ยกเลิกใบกำกับภาษีมัดจำ",
        text: "กรุณาระบุเหตุผลการยกเลิก (อย่างน้อย 3 ตัวอักษร)",
        input: "text",
        inputPlaceholder: "เหตุผลการยกเลิก",
        showCancelButton: true,
        confirmButtonText: "ยืนยันยกเลิกเอกสาร",
        cancelButtonText: "ปิด",
        confirmButtonColor: "#dc4a38",
        inputValidator: (value) => {
          if (!value || value.trim().length < 3) {
            return "กรุณาระบุเหตุผลอย่างน้อย 3 ตัวอักษร";
          }
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.patch(
              `${this.$host}/api/v1/document/deposit-tax-invoice/${item.uuid}/cancel`,
              { cancel_reason: result.value }
            );
            this.onInitData(this.currentPage);
          } catch (error) {
            this.onExceptionHandler(
              error.response ? error.response.data.message : error.message
            );
          }
        }
      });
    },
  },
};
